export default "__VITE_ASSET__CPdDgNmU__"